module.exports = __webpack_public_path__ + "img/logo-png.f712e8a2.png";